import { Carrier, IMO_CARRIERS } from "./carriers.js";
export var ReaganAutomationImo;
(function (ReaganAutomationImo) {
    ReaganAutomationImo["HEARTLAND"] = "HEARTLAND";
    ReaganAutomationImo["PINNACLE"] = "PINNACLE";
    ReaganAutomationImo["PREMIER_PRODUCERS_GROUP"] = "PREMIER_PRODUCERS_GROUP";
    ReaganAutomationImo["SMS"] = "SMS";
})(ReaganAutomationImo || (ReaganAutomationImo = {}));
export var ReaganArtifactMode;
(function (ReaganArtifactMode) {
    ReaganArtifactMode["SCREENSHOTS"] = "screenshots";
    ReaganArtifactMode["NONE"] = "none";
})(ReaganArtifactMode || (ReaganArtifactMode = {}));
export const REAGAN_CARRIER_LABELS = {
    [Carrier.ATHENE]: "Athene",
    [Carrier.BALTIMORE_LIFE]: "Baltimore Life Insurance Company",
    [Carrier.COMBINED]: "Combined",
    [Carrier.F_AND_G]: "F&G (Life)",
    [Carrier.FORESTERS]: "Foresters",
    [Carrier.ILLINOIS_MUTUAL]: "Illinois Mutual",
    [Carrier.INSTABRAIN]: "InstaBrain",
    [Carrier.KANSAS_CITY_LIFE]: "Kansas City Life Insurance",
    [Carrier.LIBERTY_BANKERS]: "Liberty Bankers",
    [Carrier.ROYAL_ARCANUM]: "Royal Arcanum",
    [Carrier.SILAC]: "SILAC",
};
export function reaganCarrierLabelsFor(carriers) {
    return carriers
        .map((carrier) => REAGAN_CARRIER_LABELS[carrier])
        .filter((label) => Boolean(label));
}
export function carriersSupportedByReagan(carriers) {
    return carriers.filter((carrier) => Boolean(REAGAN_CARRIER_LABELS[carrier]));
}
export function isReaganAutomationImo(value) {
    return typeof value === "string" && Object.values(ReaganAutomationImo).includes(value);
}
export function carriersForReaganAutomationImo(imo) {
    return IMO_CARRIERS[imo] ?? [];
}
